import { useState, useRef } from "react";
import { base_url } from "../../Constant";
import "bootstrap/dist/css/bootstrap.min.css";
import { validateForm } from "./validateForm";

const MemberJoiningForm = () => {
  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const westBengalDistricts = [
    "Alipurduar",
    "Bankura",
    "Birbhum",
    "Cooch Behar",
    "Darjeeling",
    "Dinajpur",
    "East Bardhaman",
    "East Medinipur",
    "Hooghly",
    "Howrah",
    "Jalpaiguri",
    "Jhargram",
    "Kalimpong",
    "Kanksa",
    "Kolkata",
    "Malda",
    "Medinipur",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Paschim Bardhaman",
    "Paschim Medinipur",
    "Purba Bardhaman",
    "Purnia",
    "South 24 Parganas",
    "Uttar Dinajpur",
    "West Midnapore",
  ];

  const [formData, setFormData] = useState({
    fullName: "",
    fatherName: "",
    dob: "",
    gender: "",
    email: "",
    phone: "",
    whatsapp: "",
    joinAs: "",
    presentAddress: "",
    permanentAddress: "",
    sameAsPresent: false,
    city: "",
    ps: "",
    bloodGroup: "",
    state: "West Bengal",
    stateOther: "",
    district: "",
    districtOther: "",
    pincode: "",
    politicalConnection: "",
    education: "",
    skills: "",
    interests: "",
    socialMedia: "",
    emergencyContact: "",
    reference: "",
    joiningReason: "",
    availability: "",
    consent: false,
    instituteName: "",
    startDate: "",
    endDate: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const firstErrorRef = useRef(null);

  // Mark field as touched on blur
  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]:
          type === "checkbox" ? checked : type === "file" ? files[0] : value,
      };
      if (name === "sameAsPresent" && checked) {
        updated.permanentAddress = prev.presentAddress;
      }
      return updated;
    });

    // Validate on change to update errors live
    const validationErrors = validateForm({
      ...formData,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
    setErrors(validationErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched on submit to show all errors
    const allTouched = {};
    Object.keys(formData).forEach((key) => {
      allTouched[key] = true;
    });
    setTouched(allTouched);

    // Add custom validation for state and district
    const customErrors = {};
    if (formData.state === "Other" && !formData.stateOther) {
      customErrors.stateOther = "Please enter your state name.";
    }
    if (!formData.district) {
      customErrors.district = "District is required.";
    }
    if (formData.district === "Other" && !formData.districtOther) {
      customErrors.districtOther = "Please enter your district name.";
    }
    if (!formData.politicalConnection) {
      customErrors.politicalConnection = "This field is required.";
    }

    const validationErrors = validateForm(formData);
    const allErrors = { ...validationErrors, ...customErrors };
    console.log("Validation Errors ", allErrors);
    if (Object.keys(allErrors).length > 0) {
      setErrors(allErrors);
      if (firstErrorRef.current) {
        firstErrorRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    setLoading(true);

    // Prepare payload (handle file upload separately if needed)
    const payload = {
      ...formData, // include all fields from formData
      // startDate: formData.startDate,
      // endDate: formData.endDate,
      // Add other fields as needed
    };

    // Remove stateOther if state is not "Other"
    if (payload.state !== "Other") {
      delete payload.stateOther;
    }

    // Remove districtOther if district is not "Other"
    if (payload.district !== "Other") {
      delete payload.districtOther;
    }

    try {
      const response = await fetch(`${base_url}/applymember`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          "🙌 We appreciate your enthusiasm and interest in our initiatives. Your request has been received, and our team will review it shortly. We will get back to you as soon as we can."
        );
  
        // Optionally reset form here
      } else {
        alert(`❌ Submission failed: ${result.error || "Unknown error"}`);
        console.error("API error:", result);
      }
    } catch (error) {
      alert("🚨 Network error. Please try again later.");
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Helper to conditionally add ref to first error field
  const getRefIfError = (fieldName) =>
    errors[fieldName] && touched[fieldName] ? firstErrorRef : null;

  return (
    <div className="container mt-5 position-relative">
      <img
        src="/assets/img/mlogo/mlogo.png"
        alt="Watermark"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          opacity: 0.05,
          zIndex: 0,
          width: "70%",
        }}
      />

      <div className="position-relative" style={{ zIndex: 1 }}>
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">
            📝 Mallabhum Prayas Member's Joining Form
          </h2>
          <p className="text-muted fst-italic">
            “Together we rise, together we serve.” 🤝
          </p>
        </div>

        <div className="card shadow-lg p-4">
          <form onSubmit={handleSubmit} noValidate>
            <div className="row">
              {/* Join As Dropdown */}
              <div className="col-md-6 mb-3" ref={getRefIfError("joinAs")}>
                <label className="form-label">🧭 Join As</label>
                <select
                  className="form-select"
                  name="joinAs"
                  value={formData.joinAs}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                >
                  <option value="">Select Role</option>
                  <option value="member">Member</option>
                  <option value="intern">Intern</option>
                </select>
                {errors.joinAs && touched.joinAs && (
                  <div className="text-danger">{errors.joinAs}</div>
                )}
              </div>

              {/* Basic Info Fields */}
              {[
                { label: "👤 Full Name", name: "fullName", type: "text" },
                { label: "👤 Father's Name", name: "fatherName", type: "text" },
                { label: "🎂 Date of Birth", name: "dob", type: "date" },
                {
                  label: "🚻 Gender",
                  name: "gender",
                  type: "select",
                  options: ["Select Gender", "Male", "Female", "Other"],
                },
                {
                  label: "🩸 Blood Group",
                  name: "bloodGroup",
                  type: "select",
                  options: [
                    "Select Blood Group",
                    "A+",
                    "A-",
                    "AB+",
                    "AB-",
                    "B+",
                    "B-",
                    "O+",
                    "O-",
                    "Other",
                  ],
                },
                { label: "📧 Email", name: "email", type: "email" },
                { label: "📞 Phone Number", name: "phone", type: "tel" },
                {
                  label: "💚📲 WhatsApp Number",
                  name: "whatsapp",
                  type: "tel",
                },
              ].map((field, idx) => (
                <div
                  className="col-md-6 mb-3"
                  key={idx}
                  ref={getRefIfError(field.name)}
                >
                  <label className="form-label">{field.label}</label>
                  {field.type === "select" ? (
                    <select
                      className="form-select"
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    >
                      {field.options.map((option, index) => (
                        <option
                          key={index}
                          value={option === "Select Gender" ? "" : option}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={field.type}
                      className="form-control"
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                  )}
                  {errors[field.name] && touched[field.name] && (
                    <div className="text-danger">{errors[field.name]}</div>
                  )}
                </div>
              ))}

              {/* Address Section */}
              <div
                className="col-md-6 mb-3"
                ref={getRefIfError("presentAddress")}
              >
                <label className="form-label">🏠 Present Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="presentAddress"
                  value={formData.presentAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                {errors.presentAddress && touched.presentAddress && (
                  <div className="text-danger">{errors.presentAddress}</div>
                )}
              </div>

              {/* City and Police Station */}
              {[
                { label: "🌆 Current City", name: "city" },
                { label: "👮 Current Police Station", name: "ps" },
              ].map((field, idx) => (
                <div
                  className="col-md-6 mb-3"
                  key={idx}
                  ref={getRefIfError(field.name)}
                >
                  <label className="form-label">{field.label}</label>
                  <input
                    type={field.type || "text"}
                    className="form-control"
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                  />
                  {errors[field.name] && touched[field.name] && (
                    <div className="text-danger">{errors[field.name]}</div>
                  )}
                </div>
              ))}

              {/* State */}
              <div className="col-md-6 mb-3" ref={getRefIfError("state")}>
                <label className="form-label">🌍 Current State</label>
                <select
                  className="form-select"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                >
                  <option value="">Select State</option>
                  {indianStates.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                  <option value="Other">Other</option>
                </select>
                {errors.state && touched.state && (
                  <div className="text-danger">{errors.state}</div>
                )}
              </div>

              {/* State Other - Only show if "Other" is selected */}
              {formData.state === "Other" && (
                <div className="col-md-6 mb-3" ref={getRefIfError("stateOther")}>
                  <label className="form-label">🌍 Enter Current State Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="stateOther"
                    value={formData.stateOther}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your state name"
                    required
                  />
                  {errors.stateOther && touched.stateOther && (
                    <div className="text-danger">{errors.stateOther}</div>
                  )}
                </div>
              )}

              {/* District */}
              <div className="col-md-6 mb-3" ref={getRefIfError("district")}>
                <label className="form-label">📍 Current District</label>
                <select
                  className="form-select"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                >
                  <option value="">Select District</option>
                  {westBengalDistricts.map((dist) => (
                    <option key={dist} value={dist}>
                      {dist}
                    </option>
                  ))}
                  <option value="Other">Other</option>
                </select>
                {errors.district && touched.district && (
                  <div className="text-danger">{errors.district}</div>
                )}
              </div>

              {/* District Other - Only show if "Other" is selected */}
              {formData.district === "Other" && (
                <div className="col-md-6 mb-3" ref={getRefIfError("districtOther")}>
                  <label className="form-label">📍 Enter Current District Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="districtOther"
                    value={formData.districtOther}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your district name"
                    required
                  />
                  {errors.districtOther && touched.districtOther && (
                    <div className="text-danger">{errors.districtOther}</div>
                  )}
                </div>
              )}

              {/* Pincode */}
              <div className="col-md-6 mb-3" ref={getRefIfError("pincode")}>
                <label className="form-label">📮 Current Pincode</label>
                <input
                  type="text"
                  className="form-control"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                {errors.pincode && touched.pincode && (
                  <div className="text-danger">{errors.pincode}</div>
                )}
              </div>

              {/* Political Connection */}
              <div className="col-md-6 mb-3" ref={getRefIfError("politicalConnection")}>
                <label className="form-label">🏛️ Do you have any active political connection</label>
                <select
                  className="form-select"
                  name="politicalConnection"
                  value={formData.politicalConnection}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {errors.politicalConnection && touched.politicalConnection && (
                  <div className="text-danger">{errors.politicalConnection}</div>
                )}
              </div>

              {/* Permanent Address */}
              <div
                className="col-md-6 mb-3"
                ref={getRefIfError("permanentAddress")}
              >
                <label className="form-label">🏡 Permanent Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="permanentAddress"
                  value={formData.permanentAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required={!formData.sameAsPresent}
                  disabled={formData.sameAsPresent}
                />
                {errors.permanentAddress && touched.permanentAddress && (
                  <div className="text-danger">{errors.permanentAddress}</div>
                )}
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="sameAsPresent"
                    id="sameAsPresent"
                    checked={formData.sameAsPresent}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <label className="form-check-label" htmlFor="sameAsPresent">
                    📌 Same as Present Address
                  </label>
                </div>
              </div>

              {/* Conditional Fields for Interns */}
              {formData.joinAs === "intern" && (
                <>
                  <div
                    className="col-md-6 mb-3"
                    ref={getRefIfError("instituteName")}
                  >
                    <label className="form-label">🏫 Institute Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="instituteName"
                      value={formData.instituteName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.instituteName && touched.instituteName && (
                      <div className="text-danger">{errors.instituteName}</div>
                    )}
                  </div>
                  <div
                    className="col-md-6 mb-3"
                    ref={getRefIfError("startDate")}
                  >
                    <label className="form-label">📅 Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.startDate && touched.startDate && (
                      <div className="text-danger">{errors.startDate}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3" ref={getRefIfError("endDate")}>
                    <label className="form-label">📅 End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.endDate && touched.endDate && (
                      <div className="text-danger">{errors.endDate}</div>
                    )}
                  </div>
                  <div
                    className="col-md-6 mb-3"
                    ref={getRefIfError("education")}
                  >
                    <label className="form-label">🎓 Education</label>
                    <input
                      type="text"
                      className="form-control"
                      name="education"
                      value={formData.education}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.education && touched.education && (
                      <div className="text-danger">{errors.education}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3" ref={getRefIfError("skills")}>
                    <label className="form-label">🛠️ Skills</label>
                    <input
                      type="text"
                      className="form-control"
                      name="skills"
                      value={formData.skills}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.skills && touched.skills && (
                      <div className="text-danger">{errors.skills}</div>
                    )}
                  </div>
                  <div
                    className="col-md-6 mb-3"
                    ref={getRefIfError("interests")}
                  >
                    <label className="form-label">🎯 Interests</label>
                    <input
                      type="text"
                      className="form-control"
                      name="interests"
                      value={formData.interests}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.interests && touched.interests && (
                      <div className="text-danger">{errors.interests}</div>
                    )}
                  </div>
                </>
              )}

              {/* Remaining Fields */}
              {[
                {
                  label: "🌐 Facebook Link",
                  name: "socialMedia",
                  type: "url",
                },
                {
                  label: "📱 Emergency Contact",
                  name: "emergencyContact",
                  type: "tel",
                },
                { label: "🧑‍🤝‍🧑 Reference (if any)", name: "reference" },
                { label: "📝 Reason for Joining", name: "joiningReason" },
                { label: "📆 Availability (Days/Hours)", name: "availability" },
              ].map((field, idx) => (
                <div
                  className="col-md-6 mb-3"
                  key={idx}
                  ref={getRefIfError(field.name)}
                >
                  <label className="form-label">{field.label}</label>
                  <input
                    type={field.type || "text"}
                    className="form-control"
                    name={field.name}
                    value={
                      field.type === "file"
                        ? undefined
                        : formData[field.name] || ""
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={field.name !== "reference"} // reference is optional
                    // For file input, value is read-only, so no value attribute
                  />
                  {errors[field.name] && touched[field.name] && (
                    <div className="text-danger">{errors[field.name]}</div>
                  )}
                </div>
              ))}
              {/* Consent Checkbox */}
              <div
                className="col-12 mb-3"
                ref={errors.consent ? firstErrorRef : null}
              >
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="consent"
                    id="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                    required
                  />
                  <label className="form-check-label" htmlFor="consent">
                    ✅ I agree to abide by the values and mission of Mallabhum
                    Prayas.
                  </label>
                </div>
                {errors.consent && (
                  <div className="text-danger">{errors.consent}</div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button type="submit" className="btn btn-primary px-5 py-2">
                🚀 Join Now
              </button>
            </div>
          </form>
        </div>

        {/* Loader */}
        {loading && (
          <div className="loader-overlay">
            <img
              src="/assets/img/mlogo/mlogo.png"
              alt="Loading..."
              className="loader"
            />
            <div className="loader-text">Submitting...</div>
          </div>
        )}

        {/* Footer Message */}
        <div className="mt-4 text-center text-primary fw-bold">
          🌟 Let’s build a better tomorrow—together!
        </div>
      </div>

      <style>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .loader {
          width: 100px;
          height: auto;
        }
        .loader-text {
          margin-top: 20px;
          font-size: 1.5rem;
          color: #007bff;
        }
      `}</style>
    </div>
  );
};

export default MemberJoiningForm;
